<template>
  <div>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha:</label>
        <CInput
          :value.sync="$v.form.date.$model"
          :isValid="checkIfValid('date')"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Selecione el día que está realizando el registro del documento
        </p>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Trabajador:</label>
        <v-select
          v-model="form.trabajador"
          :options="trabajadores"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona una trabajador"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
        </v-select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha de pago:</label>
        <CInput
          :value.sync="form.fecha_pago"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Corresponde a la semana en la que se le debe dar el dinero al
          trabajador (Debe seleccionar el día de inicio de su semana)
        </p>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CInput
          :value.sync="$v.form.semanas.$model"
          :isValid="checkIfValid('semanas')"
          :label="`Semanas: `"
          placeholder="Semanas..."
          type="number"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha Inicial:</label>
        <CInput
          :value.sync="$v.form.fecha_inicial.$model"
          :isValid="checkIfValid('fecha_inicial')"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Corresponde a la semana a partir de la cual se le debe descontar al
          trabajador (Debe seleccionar el día de inicio de su semana)
        </p>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CInput
          :value.sync="$v.form.monto.$model"
          :isValid="checkIfValid('monto')"
          :label="`Monto: `"
          placeholder="Monto..."
          type="number"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CTextarea
          :value.sync="form.comentarios"
          :label="`Comentarios: `"
          placeholder="Comentarios..."
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <KlayFileDD
          :fetching="fetching"
          v-model="form.medias"
          :label="`Anexos: `"
          @onFetch="onFetch"
          @onErrorFetch="onErrorFetch"
          :fetchMethod="pushMedia"
          :baseSrc="$store.getters.MediaGet"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "PrestamoForm",
  mixins: [validationMixin],
  validations: {
    form: {
      date: {
        required,
      },
      fecha_inicial: {
        required,
      },
      semanas: {
        required,
        notNegative: (value) => value >= 0,
      },
      monto: {
        required,
        notNegative: (value) => value >= 0,
      },
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      form: {
        date: "",
        trabajador: null,
        fecha_pago: null,
        semanas: null,
        fecha_inicial: null,
        monto: null,
        comentarios: "",
        medias: [],
      },
    };
  },
  created() {
    this.$emit("handledSubmit", this.handledSubmit);
    this.$emit("setData", this.setData);
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
  },
  methods: {
    onFetch() {
      this.$emit("onFetch", {});
    },
    onErrorFetch(err) {
      this.$emit("onErrorFetch", err);
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    handledSubmit() {
    debugger
      this.$v.$touch();
      console.log(this.$v)
      //   this.validatePrestamo();
      if (!this.$v.$invalid) {
        /*
      if (
        this.isValidDate &&
        this.isValidDateInitial &&
        this.isValidSemanas &&
        this.isValidMonto
      ) {
       */

        if (!this.form.trabajador) {
          return{
            error: "El campo trabajador es obligatorio",
            warningModal: true,
          };
        }

        this.isLoading = true;
        let newDate = moment(this.form.date, "YYYY-MM-DD HH:mm:ss");
        let newDateInitial = moment(this.form.fecha_inicial, "YYYY-MM-DD HH:mm:ss");

        return {
          schema: "prestamos",
          payload: {
            encabezado: {
              ...(this.folio
                ? {
                    nanoid: this.nanoid,
                    fecha_final: moment(
                      newDateInitial.format("YYYY-MM-DD"),
                      "YYYY-MM-DD"
                    )
                      .add(Number(this.semanas), "w")
                      .add(-1, "d")
                      .format("YYYY-MM-DD"),
                  }
                : {}),
              fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
              fecha_inicial: newDateInitial.format("YYYY-MM-DD"),
              fecha_pago: this.form.fecha_pago,
              trabajador_id: this.form.trabajador ? this.form.trabajador.value : "",
              semanas: Number(this.form.semanas),
              monto: Number(this.form.monto),
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
              comentarios: this.form.comentarios || "",
            },
            anexos: this.form.medias,
          },
        };
      }
      return {
        skip: true,
      };
    },
    setData(data) {
      this.form = data;
    },
  },
  props: {
    trabajadores: {
      type: Array,
      required: true,
      default: () => [],
    },
    trabajadoresAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    isLoadingPage: {
      type: Boolean,
      required: true,
      default: false,
    },
    fetching: {
      type: Boolean,
      required: true,
      default: false,
    },
    pushMedia: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
